module.exports = __webpack_public_path__ + "img/christiane-king-another-untitled.2994960.jpg";